import { Avatar, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { PageContext } from '../../../lib/context';
import { useQuery, useLazyQuery } from '@apollo/client';
import queries from '../../../utils/gql/queries';
import DashboardPage from './dashboard';

interface Customer {
  id: number;
  first_name: string;
  last_name: string;
  name: string;
  barangay: string;
  created_at: Date;
  comsumer_type: number;
  complete_address: string;
  meter_id: number;
  middle_name: string;
  mobile_number: string;
  municipality: string;
  zip_code: string;
}

type Stats = {
  subscribers: number;
  meters: number;
  unassigned: number;
  assigned: number;
};

type Map = {
  latitude: number;
  longitude: number;
  color: string;
  serial_number: string;
  meter_reading: number;
  battery: string;
  reading_date: Date;
  message: string;
  id: number;
};

export default function DashboardController() {
  const [statistics, setStats] = useState<Stats>({
    subscribers: 0,
    meters: 0,
    unassigned: 0,
    assigned: 0,
  });
  const { data, error } = useQuery(queries.GET_DASHBOARD);
  const [usersData, setUsersData] = useState<Customer[]>([]);
  const [map, setMaps] = useState<Map[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState<any>([]);
  const [green, setGreen] = useState<boolean>(true);
  const [black, setBlack] = useState<boolean>(true);
  const [gray, setGray] = useState<boolean>(true);
  const [orange, setOrange] = useState<boolean>(true);
  const [where, setWhere] = useState<any>([]);
  const [search, setSearch] = useState(null);

  const [getSubscribers, { data: subscriber_data }] = useLazyQuery(
    queries.GET_CUSTOMER_RECORD,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const { data: maps } = useQuery(queries.MAPS, {
    fetchPolicy: 'no-cache',
    variables: {
      where:
        where.length === 0
          ? {}
          : {
              _or: where,
            },
    },
  });

  const { data: stats } = useQuery(queries.GET_STATS);

  useEffect(() => {
    setWhere([
      { color: { _eq: green ? 'green' : 'purple' } },
      { color: { _eq: black ? 'black' : 'purple' } },
      { color: { _eq: gray ? 'grey' : 'purple' } },
      { color: { _eq: orange ? 'orange' : 'purple' } },
    ]);
  }, [green, black, gray, orange]);

  const _getSubscribers = () => {
    getSubscribers();
  };

  useEffect(() => {
    if (data) {
      const subscribers = [...data.subscribers].map(subscriber => {
        return {
          ...subscriber,
          name: `${subscriber.first_name} ${subscriber.last_name}`,
        };
      });
      setUsersData(subscribers);
    }
  }, [data, error]);

  useEffect(() => {
    if (stats) {
      setStats({
        subscribers: stats.subscribers.aggregate.count,
        meters: stats.meters.aggregate.count,
        unassigned: stats.unassigned.aggregate.count,
        assigned: stats.assigned.aggregate.count,
      });
    }
  }, [stats]);

  useEffect(() => {
    if (maps) {
      const values: Map[] = maps.view_map.map(
        ({
          serial_number,
          latitude,
          longitude,
          color,
          meter_reading,
          reading_date,
          battery,
          message,
          id,
        }: Map) => ({
          serial_number,
          latitude,
          longitude,
          color,
          meter_reading,
          reading_date,
          battery,
          message,
          id,
        })
      );
      setMaps(values);
    }
  }, [maps]);

  const graphData = {
    labels: ['Feb', 'March', 'April'],
    datasets: [
      {
        label: 'Monthly Revenue per thousand',
        data: [200, 350, 660, 730, 590],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(54, 162, 235, 0.2)',
        ],
      },
    ],
  };

  const usersColumns = [
    {
      title: 'Subscriber ID',
      key: 'id',
      render: (item: any) => subs_id(item.id),
    },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Address', dataIndex: 'complete_address', key: 'address' },
    {
      title: 'Status',
      key: 'status',
      render: (item: any) => (
        <Tag color="green">{item.is_active ? 'Active' : 'Inactive'}</Tag>
      ),
    },
  ];

  const subs_id = (id: number): String => {
    var sub_id = `${id}`;
    while (sub_id.length < 7) {
      sub_id = `0${sub_id}`;
    }
    return sub_id;
  };

  const _showDetails = (longitude: number, latitude: number) => {
    setShow(true);
    const items = map.filter(
      ({ longitude: lng, latitude: lat }: any) =>
        lat === latitude && lng === longitude
    );
    setDataSource(items);
  };

  const values = {
    graphData,
    data,
    statistics,
    usersData,
    usersColumns,
    map,
    show,
    dataSource,
    setShow,
    green,
    black,
    gray,
    orange,
    setGreen,
    setBlack,
    setGray,
    setOrange,
    _getSubscribers,
    _showDetails,
  };

  return (
    <PageContext.Provider value={values}>
      <DashboardPage />
    </PageContext.Provider>
  );
}
